var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.667 7.167c.486 1.243 2.5 3.748 4.166 5 0 0 .473-1.306.834-1.667.36-.36 1.163-.833 2.5-.833S15.5 12.45 15.5 13.834s-1.63 2.5-2.5 2.5C5.987 16.334.5 9.992.5 2.167.5 1.473 1.707.592 3 .5c1.904-.136 2.568.71 3.333 1.667.766.957.899 1.631.834 2.5-.036.478-.296 1.104-.834 1.667s-1.666.833-1.666.833z",
    fill: "#332C4A"
  })));
};

export default SvgPhone;